module.exports = __webpack_public_path__ + "img/logo-new.151fe49a.png";